<div class="tab">
  <button class="tablinks" routerLinkActive="active" routerLink="/terms/autorenewal" data-automation-action="Terms-Auto-Renewal">Auto Renewal</button>
  <button class="tablinks" routerLinkActive="active" routerLink="/terms/taxidentityshield" data-automation-action="Terms-Tax-Identity-Shield">Tax Identity Shield</button>
</div>

<router-outlet></router-outlet>